// extracted by mini-css-extract-plugin
export default {"tooltip":"nP-z","arrow":"oP-z"};